var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
export var buildMatchValidation = function () {
    return {
        name: "Match",
        message: "Passwords must match",
        validate: function (password, confirmPassword) {
            if (password.length === 0)
                return false;
            return password === confirmPassword;
        },
    };
};
export var buildMinLengthValidation = function (minLength) {
    return {
        name: "MinimumLength",
        message: "At least ".concat(minLength, " characters"),
        validate: function (password) {
            return password.length >= minLength;
        },
    };
};
export var buildLowercaseValidation = function () {
    return {
        name: "RequireLowercase",
        message: "At least one lowercase character",
        validate: function (password) {
            return /[a-z]/.test(password);
        },
    };
};
export var buildUppercaseValidation = function () {
    return {
        name: "RequireUppercase",
        message: "At least one uppercase character",
        validate: function (password) {
            return /[A-Z]/.test(password);
        },
    };
};
export var buildNumberValidation = function () {
    return {
        name: "RequireNumbers",
        message: "At least one number",
        validate: function (password) {
            return /[0-9]/.test(password);
        },
    };
};
export var buildSpecialCharacterValidation = function () {
    return {
        name: "RequireSpecialCharacters",
        message: "At least one special character",
        validate: function (password) {
            return /[^A-Za-z0-9]/.test(password);
        },
    };
};
export var PasswordValidator = function (_a) {
    var password = _a.password, confirmPassword = _a.confirmPassword, validationRules = _a.validationRules, onValidate = _a.onValidate;
    var _b = React.useState([]), validations = _b[0], setValidations = _b[1];
    React.useEffect(function () {
        var validations = validationRules.map(function (rule) {
            return {
                rule: rule,
                valid: false,
            };
        });
        setValidations(validations);
    }, []);
    React.useEffect(function () {
        var runValidations = function () {
            return validations.map(function (validation) {
                var isValid = validation.rule.validate(password, confirmPassword);
                return { rule: validation.rule, valid: isValid };
            });
        };
        if (validations.length > 0) {
            setValidations(runValidations());
        }
    }, [password, confirmPassword]);
    React.useEffect(function () {
        var valid = validations.every(function (validation) {
            return validation.valid;
        });
        onValidate(valid);
    }, [validations]);
    var renderValidItem = function (validation) {
        return (_jsxs("li", __assign({ className: "list-unstyled" }, { children: [_jsx("span", __assign({ className: "mr-2" }, { children: _jsx(FontAwesomeIcon, { icon: faCheck, color: "#0BB783" }) })), _jsx(SuccessText, { children: validation.rule.message })] }), validation.rule.name));
    };
    var renderInvalidItem = function (validation) {
        return (_jsxs("li", { children: [_jsx("span", __assign({ className: "mr-2" }, { children: _jsx("span", { children: "\u2022" }) })), validation.rule.message] }, validation.rule.name));
    };
    var renderValidationItems = function () {
        return validations.map(function (validation) {
            return validation.valid
                ? renderValidItem(validation)
                : renderInvalidItem(validation);
        });
    };
    return (_jsxs("div", __assign({ className: "text-left border py-4 px-8 mb-5" }, { children: [_jsx("span", { children: "Password requirements:" }), _jsx("ul", __assign({ className: "mb-0 list-unstyled" }, { children: renderValidationItems() }))] })));
};
var SuccessText = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: #0bb783;\n"], ["\n  color: #0bb783;\n"])));
var templateObject_1;
